import Img17 from "../../../assets/images/17.png";
import {Card, Image, Watermark} from "antd";
import {
  EditOutlined,
  HeartFilled,
  ShoppingCartOutlined,
  EyeOutlined,
  HeartOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { SHAPE_LIST } from "../../../enums/Enum";
import { useState } from "react";
import { useSelector } from 'react-redux';
import { addToFavorites, removeToFavorites, selectFavorites } from "../../../app/store/reducers/main/mainReducer";
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { PATH_IMAGE } from "../../../helper/path";
import { productDeleteAsync } from "../../../app/store/reducers/product/productReducer";


const Product = ({random, owner, product, shape}) => {

  const color = 'rgba(0, 0, 0, 0.25)'
  const watermarkProps = {
    content: 'Monaliza',
    zIndex: 0,
    font: {
      color: typeof color === 'string' ? color : color.toRgbString(),
      fontSize: 23,
    },
  };


  const favorites = useSelector(selectFavorites)
  const [addToFavorite, setAddToFavorite] = useState(favorites?.some(x => x?.id === product?.id))

  const dispatch = useDispatch()
  
  const handleToFavorite = () => {
    if (addToFavorite) {
      dispatch(removeToFavorites(product))
      setAddToFavorite(!addToFavorite)
    } else {
      dispatch(addToFavorites(product))
      setAddToFavorite(!addToFavorite)
    }
  }

  const removeHandler = async () => {
    await productDeleteAsync({id: product?.id})
      .then((response) => {

      })
      .catch((error) => {

      })
  }


  return (
    <>
    <Watermark {...watermarkProps}>

      <Card
        style={{
        //   width: 300,
            display: SHAPE_LIST === shape ? "flex" : ""
        }}
        cover={
          <Image
            height={200}
            // width={350}
            style={SHAPE_LIST === shape ? {width: "350px"} : {}}
            // src={Img17}
            src={`${PATH_IMAGE}${product?.image?.path}`}
          />
        }
        bodyStyle={{
            display: "flex",
            // flexDirection: SHAPE_LIST === shape ? "" : "column" , 
            // justifyContent: "space-between",
            width: "100%"
        }}
        // actions={[
        //   <ShoppingCartOutlined
        //     key="shopping"
        //     style={{fontSize: "25px", color: "gray"}}
        //   />,
        //   <EditOutlined
        //     key="edit"
        //     style={{fontSize: "25px", color: "orange"}}
        //   />,
        //   <HeartFilled
        //     key="favorite"
        //     style={{fontSize: "25px", color: "red"}}
        //   />,
        // ]}
      >
        {/* <Card.Meta title="Flower shape" /> */}
        <div className={`d-flex ${SHAPE_LIST === shape ? "justify-content-between" : "flex-column"}`} style={{width: "100%"}}>
        <div>
        {/* <h4>Flower shape</h4> */}
        <h4>{product?.name}</h4>
        {/* <h4 className="p-0 mt-1 fw-bold">$32.00</h4> */}
        <h4 className="p-0 mt-1 fw-bold">${product?.price?.amount}</h4>
        {/* <span>Time: 6:08PM 1.25.2024</span> */}
        {/* <span>Time: {dateFormatter(product?.created_at)}</span> */}
        <span>Time: {product?.created_at}</span>
        </div>

        <div className={`d-flex justify-content-between ${SHAPE_LIST === shape ? "flex-column" : "mt-3"}`}>
          {random &&
            <ShoppingCartOutlined
            key="shopping"
            style={{fontSize: "25px", color: "gray"}}
          />
          }
          
          {!random &&
            <>
              <Link to={`/product/update/${product?.id}`}>
            <EditOutlined
              key="edit"
              style={{fontSize: "25px", color: "orange"}}
            />
            </Link>
            <DeleteOutlined
              key="delete"
              style={{fontSize: "25px", color: "red", cursor: "pointer"}}
              onClick={() => removeHandler()}
            />
            </>
          }

          {/* <Link to={`/product/view/${product?.id}`}> */}
          {random &&
            <Link to={`/product/random/view/${product?.id}`}>
            <EyeOutlined
              key="eye"
              style={{fontSize: "25px", color: "lightblue"}}
            />
            </Link>
          }
          {/* <HeartFilled */}
          {/* <HeartOutlined
            onClick={() => setAddToFavorite(!addToFavorite)}
            key="favorite"
            style={{fontSize: "25px", color: addToFavorite ? "red" : "white"}}
          /> */}
          {random &&
            <>
              {addToFavorite ?
              <HeartFilled
              // onClick={() => setAddToFavorite(!addToFavorite)}
              onClick={() => handleToFavorite()}
              key="favorite"
              style={{fontSize: "25px", color: "red"}}
            />
              :
              <HeartOutlined
              // onClick={() => setAddToFavorite(!addToFavorite)}
              onClick={() => handleToFavorite()}
              key="favorite"
              style={{fontSize: "25px", color: "red"}}
            />
            }
            </>
          }
        </div>
        </div>
      </Card>
    </Watermark>
    </>
  );
};

export default Product;
